/**
 * MM Product Sticky — barre d'achat fixe (mobile) + modale de choix de taille.
 *
 * [2026-09-30] Remplace le pilotage historique `initializeStickyCTA()` de
 * mm-main-product.js, qui cherche [data-sticky-cta] : le gabarit expose
 * desormais [data-mm-sticky-cta], l'ancienne fonction sort donc immediatement
 * et ne touche plus a rien.
 *
 * Comportement demande :
 *   - la barre est visible des l'arrivee sur la fiche produit ;
 *   - elle disparait des qu'on atteint les boutons d'achat de la colonne ;
 *   - elle ne revient jamais, meme en remontant.
 *
 * Le bouton n'ajoute plus directement au panier quand le produit a plusieurs
 * tailles : il ouvre une modale de selection (reference : wolford.com). Un clic
 * sur une taille ajoute la variante correspondante — rallonge comprise si la
 * case est cochee, via mmAddProductWithUpsell.
 *
 * Degradable : sans ce fichier la barre reste simplement affichee et le bouton
 * n'ouvre rien. Aucun autre comportement de la fiche n'en depend.
 */
(function () {
	'use strict';

	var HTML_OPEN_CLASS = 'mc-size-modal-open';

	function init() {
		var bar = document.querySelector('[data-mm-sticky-cta]');
		if (!bar) return;
		if (bar.dataset.mmStickyInit === '1') return;
		bar.dataset.mmStickyInit = '1';

		var modal = document.querySelector('[data-mm-size-modal]');
		var addButton = bar.querySelector('[data-mm-sticky-add]');
		var lastFocus = null;

		/* ------------------------------------------------- Ajout au panier */

		function addVariant(variantId) {
			var id = Number(variantId);
			if (!id) return;

			if (typeof window.mmAddProductWithUpsell === 'function') {
				window.mmAddProductWithUpsell(id, { openCart: true });
			} else if (typeof window.mmAddProductToCart === 'function') {
				window.mmAddProductToCart(id, { openCart: true });
			}
		}

		/* -------------------------------------------------------- Modale */

		function openModal() {
			if (!modal) return;
			lastFocus = document.activeElement;
			modal.hidden = false;
			/* Reflow force avant de poser la classe : sans lui la transition
			   d'entree ne joue pas (l'element vient de quitter display:none).
			   Volontairement synchrone plutot qu'un requestAnimationFrame, qui
			   ne s'execute pas dans un onglet non rendu. */
			void modal.offsetWidth;
			modal.classList.add('is-open');
			document.documentElement.classList.add(HTML_OPEN_CLASS);

			var first = modal.querySelector('[data-mm-size-option]:not([disabled])');
			if (first) first.focus();
		}

		function closeModal() {
			if (!modal || modal.hidden) return;
			modal.classList.remove('is-open');
			document.documentElement.classList.remove(HTML_OPEN_CLASS);

			var hide = function () { modal.hidden = true; };
			/* On attend la fin de la transition de sortie, avec un filet de
			   securite si l'evenement ne vient pas (prefers-reduced-motion). */
			var done = false;
			modal.addEventListener('transitionend', function once() {
				if (done) return;
				done = true;
				modal.removeEventListener('transitionend', once);
				hide();
			});
			window.setTimeout(function () { if (!done) { done = true; hide(); } }, 500);

			if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
		}

		if (addButton) {
			addButton.addEventListener('click', function (event) {
				event.preventDefault();

				var single = addButton.getAttribute('data-mm-variant');
				if (single) {
					addVariant(single);
					return;
				}
				if (modal) {
					openModal();
				}
			});
		}

		if (modal) {
			modal.addEventListener('click', function (event) {
				var close = event.target.closest && event.target.closest('[data-mm-size-close]');
				if (close) {
					event.preventDefault();
					closeModal();
					return;
				}

				var option = event.target.closest && event.target.closest('[data-mm-size-option]');
				if (option && !option.disabled) {
					event.preventDefault();
					addVariant(option.getAttribute('data-mm-variant'));
					closeModal();
				}
			});

			document.addEventListener('keydown', function (event) {
				if (event.key !== 'Escape' && event.key !== 'Esc') return;
				if (modal.hidden) return;
				closeModal();
			});
		}

		/* ------------------------------------------------- Visibilite */

		var mainCta = document.querySelector('.mm-product-form-component-cta-initial')
			|| document.querySelector('[data-cta]');

		if (!mainCta) return;

		/* Verrou a sens unique : des que le haut des boutons d'achat de la
		   colonne entre dans l'ecran, la barre a fait son office et ne
		   reapparait plus, meme si on remonte.
		   On compare les rectangles plutot que d'utiliser un
		   IntersectionObserver : un defilement tres rapide peut faire passer
		   l'element d'en dessous a au-dessus de l'ecran sans qu'aucune frame
		   ne le voie intersecter, et la barre resterait alors affichee. */
		var ticking = false;

		function dismissIfReached() {
			ticking = false;
			if (mainCta.getBoundingClientRect().top > window.innerHeight) return;

			bar.classList.add('mm-none');
			closeModal();
			window.removeEventListener('scroll', onScroll);
			window.removeEventListener('resize', onScroll);
		}

		function onScroll() {
			if (ticking) return;
			ticking = true;
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(dismissIfReached);
			} else {
				window.setTimeout(dismissIfReached, 16);
			}
		}

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll, { passive: true });
		dismissIfReached();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	document.addEventListener('shopify:section:load', init);
})();
